import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { queryKeys } from '~/features/auth/utils'
import { TErrorMutateUserResponse, TUser } from '~/features/user/models'
import { queryKeys as userQueryKeys } from '~/features/user/utils'
import { EServerPath } from '~/models/api'
import HttpService from '~/services/http'

type TCreateUser = {
  cognitoUid: string
  partnerId: string
  email: string
  tempDemoOrg: boolean
}

const useCreateUser = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: TCreateUser) =>
      HttpService.post<TUser | TErrorMutateUserResponse>({
        path: EServerPath.users,
        payload,
      }),
    onSuccess(response, variables) {
      const userId = (response?.data as TUser)?.id

      queryClient.invalidateQueries({ queryKey: queryKeys.authSession() })
      queryClient.invalidateQueries({
        queryKey: userQueryKeys.userCognito(variables.cognitoUid),
      })

      queryClient.setQueryData(
        userQueryKeys.user(userId),
        response?.data || undefined,
      )

      queryClient.invalidateQueries({
        queryKey: userQueryKeys.user(userId),
      })
    },
    onError: () => {
      toast.error('An error occurred while creating the user.')
    },
  })
}

export default useCreateUser
